/* @flow */

import * as React from 'react';
import styled from '@emotion/styled';

type Props = {
  children: any,
  htmlFor?: string,
  lightContent?: boolean,
  required?: boolean,
  uppercase?: boolean
};

const defaultProps = {
  htmlFor: undefined,
  lightContent: false,
  required: false,
  uppercase: true
};

const StyledLabel = styled.label(
  ({ lightContent, theme, uppercase }) => ({
    color: lightContent ? theme.color.basis2 : theme.color.basis5,
    fontSize: theme.fontSize.xsmall,
    marginBottom: theme.spacing.xsmall,
    textTransform: uppercase ? 'uppercase' : 'none'
  }),
  ({ theme, required }) =>
    required
      ? {
          '&::after': {
            color: theme.color.danger,
            content: '" *"'
          }
        }
      : undefined
);

function FormLabel({ children, htmlFor, lightContent, required, uppercase }: Props) {
  return (
    <StyledLabel
      htmlFor={htmlFor}
      lightContent={lightContent}
      required={required}
      uppercase={uppercase}
    >
      {children}
    </StyledLabel>
  );
}

FormLabel.defaultProps = defaultProps;

export default FormLabel;
